export const ru = {
    'banner-image-desc1':
        'Правильно подобранные изображения привлекают к рекламе больше внимания и помогают быстрее понять суть предложения.',
    'banner-image-desc2':
        'Мы рекомендуем создавать два варианта каждого объявления: со стандартным (от 1:1 до 4:3/3:4) и с широкоформатным (16:9) изображением. Так ваши объявления будут показаны на всех доступных площадках.',
    'normal-view-title': 'Добавьте изображения в объявления',
    'normal-view-title-hint': 'Показывается, потому что у вас есть объявления без изображений',
    'popup-view-title': 'Добавьте изображения в объявление',
    'popup-view-title-hint': 'Показывается, потому что у объявления нет изображений',
    'show-many-banner-button': 'Посмотреть {count} объявлений',
    'show-one-banner-button': 'Посмотреть {count} объявление',
    'show-some-banner-button': 'Посмотреть {count} объявления',
    'with-image': 'С изображением',
    'without-image': 'Без изображения'
};
